import { getStreamHealthUrl } from '../config/apiConfig';

/**
 * Fetches real stream health metrics from the active API endpoint.
 * Returns exact error given by the API/browser without injecting URL or hardcoded messages.
 */
export const fetchStreamHealth = async () => {
  const url = getStreamHealthUrl();
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 6000); // 6 sec timeout

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      // If backend returns JSON with an error/reason message, attempt parsing it first
      try {
        const errorJson = await response.json();
        const serverMsg = errorJson.message || errorJson.error || errorJson.reason;
        if (serverMsg) {
          throw new Error(`HTTP ${response.status}: ${serverMsg}`);
        }
      } catch (e) {
        // Fall back to status text if JSON parsing fails
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText || 'Server Error'}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    let message = error.message;
    if (error.name === 'AbortError') {
      message = 'Request timed out';
    }
    return { data: null, error: message };
  }
};
